import React, { useEffect, useState } from 'react';
import StaffLayout from '../../layouts/StaffLayout';
import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, Chip, Button, Paper, CircularProgress } from '@mui/material';
import api from '../../services/api';
import HotelModal from '../../components/HotelModal';

function StaffPackagesPage() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hotels, setHotels] = useState([]);
  const [hotelModalOpen, setHotelModalOpen] = useState(false);
  const [editHotel, setEditHotel] = useState(null);

  const fetchPackages = () => {
    setLoading(true);
    api.get('/api/packages')
      .then(res => setPackages(res.data.packages || res.data || []))
      .finally(() => setLoading(false));
  };
  const fetchHotels = () => {
    api.get('/api/hotels')
      .then(res => setHotels(res.data.hotels || res.data || []));
  };
  useEffect(() => { fetchPackages(); fetchHotels(); }, []);

  const handleHotelModalSave = () => { setHotelModalOpen(false); fetchHotels(); };

  return (
    <StaffLayout>
      <Box sx={{ mb: 4, px: { xs: 1, md: 0 } }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Packages Management
        </Typography>
        {loading ? <CircularProgress sx={{ my: 3 }} /> : (
          <Paper sx={{ p: 2, borderRadius: 2, mb: 3 }}>
            <Table sx={{ borderRadius: 2, boxShadow: 2, overflow: 'hidden' }}>
              <TableHead>
                <TableRow sx={{ bgcolor: 'background.paper' }}>
                  <TableCell>Name</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Capacity</TableCell>
                  <TableCell>Includes</TableCell>
                  <TableCell>Hotels</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {packages.map((pkg) => (
                  <TableRow key={pkg._id}>
                    <TableCell>{pkg.name}</TableCell>
                    <TableCell>{pkg.category}</TableCell>
                    <TableCell>{pkg.price}</TableCell>
                    <TableCell>{pkg.capacity}</TableCell>
                    <TableCell>{(pkg.includes || []).map((inc, i) => <Chip key={i} label={inc} size="small" sx={{ mr: 0.5 }} />)}</TableCell>
                    <TableCell>{(pkg.hotels || []).map(h => <Chip key={h._id} label={h.name} size="small" sx={{ mr: 0.5 }} />)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        )}
        <Button variant="outlined" color="secondary" sx={{ mb: 2, ml: 0 }} onClick={() => { setEditHotel(null); setHotelModalOpen(true); }}>Manage Hotels</Button>
        <Box sx={{ mt: 4 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>Hotels / Accommodation</Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>Rooms</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {hotels.map(hotel => (
                <TableRow key={hotel._id}>
                  <TableCell>{hotel.name}</TableCell>
                  <TableCell>{hotel.address}</TableCell>
                  <TableCell>{(hotel.rooms || []).map((r, i) => <Chip key={i} label={`${r.type} - ${r.price}`} size="small" sx={{ mr: 0.5 }} />)}</TableCell>
                  <TableCell>
                    <Button size="small" variant="outlined" onClick={() => { setEditHotel(hotel); setHotelModalOpen(true); }}>Manage</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <HotelModal open={hotelModalOpen} onClose={() => setHotelModalOpen(false)} onSave={handleHotelModalSave} editHotel={editHotel} />
      </Box>
    </StaffLayout>
  );
}

export default StaffPackagesPage;
